import {avatarEndpoint, getFriendlyUUID} from '.'

export function generateAvatarUrl(apiUrl: string, userId: string, updatedAt: Date, small: boolean = false) {
  return `${apiUrl}${avatarEndpoint}/${getFriendlyUUID(userId)}${small ? '_small' : ''}?t=${updatedAt.getTime()}`
}
